import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import IconArrowLeft from 'components/icons/IconArrowLeft';

import pxToRem from 'styles/pxToRem';
import pxToEm from 'styles/pxToEm';

const styles = theme => ({
  root: {
    position: 'relative',
  },
  typographyLabel: {
    marginBottom: 10,
    [theme.breakpoints.down('sm')]: {
      marginBottom: 4,
    },
    fontSize: pxToRem(12),
    letterSpacing: pxToEm(0.5),
    fontWeight: 700,
    color: theme.palette.grey[600],
    transform: 'none',
  },
  typographyValue: {
    padding: '10px 10px 10px 10px',
    lineHeight: pxToEm(16, 16),
    borderRadius: 4,
    border: `1px dashed ${theme.palette.primary.A400}`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  iconArrowLeft: {
    position: 'absolute',
    right: -16,
    bottom: 13,
    width: 10,
    height: 10,
    margin: '-2px 0 0 10px',
    verticalAlign: 'middle',
    transform: 'rotate(180deg)',
    color: theme.palette.primary[500],
  },
});

const WorkflowStatusReassignOldWorkflowStatusNameField = ({ label, classes, input }) => {
  return (
    <div className={classes.root}>
      <Typography className={classes.typographyLabel}>
        {label}
      </Typography>
      <Typography className={classes.typographyValue}>
        {input.value}
      </Typography>
      <IconArrowLeft className={classes.iconArrowLeft} />
    </div>
  );
};

WorkflowStatusReassignOldWorkflowStatusNameField.propTypes = {
  label: PropTypes.string.isRequired,
  input: PropTypes.shape({
    value: PropTypes.string.isRequired,
  }).isRequired,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
  }).isRequired,
};

export default withStyles(styles)(WorkflowStatusReassignOldWorkflowStatusNameField);



// WEBPACK FOOTER //
// ./src/components/settings/WorkflowStatusReassignDialog/WorkflowStatusReassignOldWorkflowStatusNameField.js